import { useState } from 'react';
import { Flex } from '.';
import { theme } from '../../design-system';
import { useAuth } from '../../../../context/authContext';
import { useVideo } from '../../../../context/videoContext';
import { keyframes } from '@emotion/react';
import { useTestContext } from '../../../../context/testContext';
import { usePostMessage } from '../../../../context/messageContext';
import { confirmNavigation } from '../../../../helpers/functions';
import { useResultData } from '../../../../helpers/useResultData';

const enterFromLeft = keyframes`
from {
  transform: translateX(calc(-100vw))
}

to {
  transform: translateX(0)
}`;

const ResponsiveMenu = ({ setMenuOpen, setActiveTab, setVideoChatScreenOpen, tabletInPortrait }) => {
  const [pressedItem, setPressedItem] = useState(null);
  const { logout } = useAuth();
  const { disconnect } = useVideo();
  const { clearAllResults } = useResultData();
  const postMessage = usePostMessage();
  const {
    testData: { testInProgress },
  } = useTestContext();

  const menuListItems = [
    { name: 'Calibration', route: 'calibration-selection' },
    { name: 'Set Distance', route: 'set-distance' },
    { name: 'Examinations', route: 'test' },
    { name: 'Completed Examinations', route: 'results' },
    { name: 'Consultation View', route: 'consultationView' },
    { name: 'Logout', route: 'logout' },
  ];

  const handleLogout = () => {
    logout();
    disconnect();
  };

  const handleMenuPress = (route) => {
    if (route === 'logout') {
      return handleLogout();
    }

    if (route === 'consultationView') {
      setMenuOpen(false);
      return setVideoChatScreenOpen(true);
    }

    if (route === 'test') postMessage({ type: 'testNavigationReset' });
    setActiveTab(route);
    return setMenuOpen(false);
  };

  return (
    <Flex
      column
      height='calc(100vh - 55px)'
      width='100vw'
      position='fixed'
      top='55px'
      animation={`${enterFromLeft} 200ms forwards`}
      backgroundColor='white'
      left='0'
      zIndex='100'
      overflow='hidden'
    >
      {menuListItems.map((item) => {
        return tabletInPortrait && item.route === 'consultationView' ? null : (
          <Flex
            onMouseDown={() => setPressedItem(item.name)}
            onClick={() => {
              if (testInProgress)
                return confirmNavigation().then(() => {
                  clearAllResults();
                  return handleMenuPress(item.route);
                });
              return handleMenuPress(item.route);
            }}
            backgroundColor={pressedItem === item.name ? theme.colors.backgroundShade : 'transparent'}
            padding='1rem'
            key={`menu-list-item-${item.name}`}
          >
            {item.name}
          </Flex>
        );
      })}
    </Flex>
  );
};

export default ResponsiveMenu;
